module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/offcar_wallpaper-bee9f21a376655fc589ca625e478b9fa.jpg";